import { IStockoutData } from "interfaces/IStockout"
import { api as apiService, ApiService } from "./api"
import { IParamsPagination } from "shared/TableCustom/types"
import { IPaginationResponse } from "interfaces/IPagination"

class StockoutService {
  constructor(private readonly api: ApiService) {}

  public getAllStockout = async (
    params: IParamsPagination,
  ): Promise<IPaginationResponse<object>> => {
    return await this.api.get(toranjaURL + `/stockout/`, {
      params,
    })
  }

  public createStockout = async (data: IStockoutData) => {
    return await this.api.post(toranjaURL + "/stockout/", data)
  }

  public deleteStockout = async (id: number) => {
    return await this.api.delete(toranjaURL + `/stockout/${id}`)
  }
}
const toranjaURL = process.env.REACT_APP_TORANJA_API
export const stockoutService = new StockoutService(apiService)
